<template>
  <div class="container">
    <h1 class="text-center sm">
      <base-button @click="goBack" size="md" class="back-button mt-1" type="primary" nativeType='submit'>Back</base-button>
      Job Actions</h1>
    <div class="card card-profile shadow mb-3">
      <div class="card-body">
        <b-list-group>
          <b-list-group-item>
            <span class="pull-right" v-if="isJobActionCopleted(1)">completed</span>
            <router-link :to="{ name: 'jobaction', params: { action: 1 } }">Stand Service</router-link>
          </b-list-group-item>
          <b-list-group-item>
            <span class="pull-right" v-if="isJobActionCopleted(2)">completed</span>
            <router-link :to="{ name: 'jobaction', params: { action: 2 } }">Eboard Service</router-link>
          </b-list-group-item>
          <b-list-group-item>
            <span class="pull-right" v-if="isJobActionCopleted(3)">completed</span>
            <router-link :to="{ name: 'jobaction', params: { action: 3 } }">Tablet Service</router-link>
          </b-list-group-item>
          <b-list-group-item>
            <span class="pull-right" v-if="isJobActionCopleted(4)">completed</span>
            <router-link :to="{ name: 'jobaction', params: { action: 4 } }">Delivery</router-link>
          </b-list-group-item>
          <b-list-group-item>
            <span class="pull-right" v-if="isJobActionCopleted(5)">completed</span>
            <router-link :to="{ name: 'jobaction', params: { action: 5 } }">Stand Info</router-link>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
  </div>
</template>

<script>
import jobActionsMixin from './../mixins/jobActionsMixin'
import jobsMixin from './../mixins/jobsMixin'
import standsMixin from './../mixins/standsMixin'
export default {
  data () {
    return {
      standId: null
    }
  },
  mounted () {
    this.getStandId()
  },
  methods: {
    getStandId () {
      this.standId = this.$store.state.currentStand
    },
    goBack () {
      let currentJobId = this.$store.state.currentJob
      this.$router.push({ name: 'job', params: { id: currentJobId } })
    }
  },
  mixins: [jobActionsMixin, standsMixin, jobsMixin]
}
</script>
<style lang="css">

</style>
